<template>
  <div>
    <incredi-icon-button
      v-if="totalNotificationsCount"
      :active="menu"
      :icon-color="COLORS['Text/Dark']"
      badge-color="#e12828"
      class="notifications-bell"
      :badge-width="badgeIconWidth"
      :badge-height="defaultHeight"
      :badge-text="notificationBadgeText"
      :border-radius="isShortDisplay ? `${defaultHeight}` : '50%'"
      :badge-right="isShortDisplay ? '-8%' : '9%'"
    >
      <q-menu
        v-model="menu"
        :offset="[0, 10]"
        square
        class="action-menu"
        content-class="generic-menu-shadow"
        anchor="bottom right"
        self="top right"
        @hide="updateMessagesState"
      >
        <messages-content />
      </q-menu>
    </incredi-icon-button>
  </div>
</template>

<script>
import { useCommonDataLazyQuery } from '@/graphql/codegen/generated/graphql';
import { defineComponent, inject } from 'vue';
import { IKCoordinatorsService } from '@/modules/CoordinatorsService/CoordinatorService.InjectionKeys';
import COLORS from '@/design-system/colors.json';
import { IKCommonPersistentData } from '@/components/common/services/commonDataService.types';
import incrediIconButton from '../../incrediIconButton.vue';
import messagesContent from './messages-content.vue';

export default defineComponent({
  name: 'MessageNotifications',
  components: { incrediIconButton, messagesContent },
  setup() {
    const commonPersistentData = inject(IKCommonPersistentData);
    const coordinatorsService = inject(IKCoordinatorsService);
    const GQL_commonDataQuery = useCommonDataLazyQuery(() => ({ coordinatorId: coordinatorsService?.selectedCoordinator.value || '' }), {
      fetchPolicy: 'network-only',
      nextFetchPolicy: 'cache-first',
    });
    GQL_commonDataQuery.load();

    return { GQL_commonDataQuery, commonPersistentData, COLORS };
  },
  data() {
    return {
      menu: false,
      notificationShortDisplayMinNumber: 9,
      defaultHeight: '16px',
    };
  },
  computed: {
    totalNotificationsCount() {
      return this.GQL_commonDataQuery?.result?.value?.ibManagerEntities?.notificationsCount?.totalCount || 0;
    },
    badgeIconWidth() {
      const defaultBadgeWidth = '16px';
      const badgeWithPlusWidth = '22px';
      return this.isShortDisplay ? badgeWithPlusWidth : defaultBadgeWidth;
    },
    lastNotificationIndexSeen() {
      return Number(this.commonPersistentData?.getNotificationsLastNotificationIndexSeen.value) || 0;
    },
    isShortDisplay() {
      return this.notificationBadgeCount > this.notificationShortDisplayMinNumber;
    },
    notificationBadgeText() {
      const count = this.notificationBadgeCount;
      return this.isShortDisplay ? `${this.notificationShortDisplayMinNumber}+` : count?.toString();
    },
    notificationBadgeCount() {
      const count = this.totalNotificationsCount - this.lastNotificationIndexSeen;
      if (!this.commonPersistentData?.getNotificationsLastNotificationIndexSeen.value) return undefined;
      return count > 0 ? count : undefined;
    },
  },
  methods: {
    updateMessagesState() {
      this.commonPersistentData?.setNotificationsLastNotificationIndexSeen(this.totalNotificationsCount);
    },
  },
});
</script>

<style lang="scss" scoped>
.notifications-bell {
  background-image: url('@/assets/images/icons/header_bell.svg');
  background-repeat: no-repeat;
  background-position: center;
  margin-left: 24px;

  &.incrediIcon-button:hover {
    background-image: url('@/assets/images/icons/header_bell.svg');
    background-repeat: no-repeat;
    background-position: center;
  }
}
</style>
